import EventFilterForm from './component'

export default EventFilterForm
